module.exports = __webpack_public_path__ + "static/media/a-value.185803ac.png";